import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { debounce } from "throttle-debounce";
import './FilterInput.css';

import IconToggleOff from './svg/IconToggleOff';
import IconToggleOn from './svg/IconToggleOn';

function FilterToggle({ flexShrink, type, placeholder, value, onValid }) {
  const [enable, setEnable] = useState(!!value);
 
  const debouncedApply = useCallback(debounce(1000, (v) => {
    onValid(type, v)
  }), [])
  const search = (value) => {
    debouncedApply(value);
  }
  const onClick = () => {
    const newState = !enable;
    setEnable(newState);
    search(newState);
  }

  return (
    <div className={`flexRow align filter-container fc-min-width ${flexShrink > 1 && `small`} `}
      style={{ flexShrink, flexGrow: 0 }}
      tabIndex={0}
    >
      <span style={{fontSize: 13, color: '#757575'}}>{placeholder}</span>
      <div style={{cursor: 'pointer'}} onClick={onClick}>
        { enable ? <IconToggleOn /> : <IconToggleOff /> }
      </div>
    </div>
  )
}

FilterToggle.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onValid: PropTypes.func.isRequired
}

export default FilterToggle;
